import ReactDOM from 'react-dom/client';
import { fetchJSON } from '../../../rise/hyperlive/utils';
import Escalator from './Escalator';

const json_data = fetchJSON()?.json_data ?? {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Escalator muted={true} data={json_data} />);
